import {ReactComponent as ShoppingIcon} from "../../assets/shopping-bag.svg";

import {CartIconContainer, ItemCount} from "./cart-icon.styles";
import {useDispatch, useSelector} from "react-redux";
import {selectCartCount, selectIsCartOpen} from "../../store/cart/cart.selector";
import {setIsCartOpen} from "../../store/cart/cart.action";


const CartIcon = () => {
    const isCartOpen = useSelector(selectIsCartOpen);
    const dispatch = useDispatch();
    const toggleIsCartOpen = () => dispatch(setIsCartOpen(!isCartOpen));

    const cartCount = useSelector(selectCartCount);

    return(
      <CartIconContainer onClick={toggleIsCartOpen}>
          <ShoppingIcon className='shopping-icon' />
          <ItemCount>{cartCount}</ItemCount>
      </CartIconContainer>
    );
}

export default CartIcon;


